'use client';

import { Separator } from '@gartner-digital-markets/nimbus-v3-ui';
import { cn } from '../ui/utils';

interface FormHeadlineProps {
  title: string;
  subtitle?: string;
  showRuler?: boolean;
  className?: string;
}

export const FormHeadline = ({
  title,
  subtitle,
  showRuler,
  className,
}: FormHeadlineProps) => (
  <div className={cn('text-nimbus-foreground', className)}>
    <h2
      className={cn(
        'text-2xl leading-8 tracking-[-1px] font-bold md:text-[32px] md:leading-10',
        {
          'mb-5': !(showRuler || subtitle),
        }
      )}
    >
      {title}
    </h2>
    {showRuler && <Separator className="mt-6 mb-4 border-nimbus-border" />}
    {subtitle && <h3 className="mb-4 mt-5 text-base leading-6">{subtitle}</h3>}
  </div>
);
